import { useContext } from "react";
import { useSelector } from "react-redux";
import { GlobalStateModel } from "store/global-state/types";
import { AppContext, AppStateContext } from "./AppContext";

export function useAppState() {
  const state = useContext<AppContext>(AppStateContext);
  return state;
}

export function useGlobalState() {
  const globalState = useSelector<any, GlobalStateModel>(
    (state: any) => state.GlobalState
  );
  return globalState;
}